let interval = setInterval(function () {
  let apElements = document.querySelector('.apo-cart-item');
  if (apElements){
    let themeQtyBtns = document.querySelectorAll('.qty-button:not(.apo-hidden)');
    for(let item of themeQtyBtns) {
      item.addEventListener("click", (e) => {
        console.log("ok");
        location.reload();
      });
    }
    
    clearInterval(interval);
  }
}, 100);

// function forceQuitInterval(){
//   clearInterval(interval);
// }

// setTimeout(forceQuitInterval, 10000);